import React from 'react';
import Logout from "../../Assets/Svg/Auth/Logout.svg";
import './styles.scss';


const LogoutModal = ({ onCancel, onLogout }) => {
    return (
      <div className="logout-modal" > 
        <div className="logout-modal-content">
          <div className="logout-icon">
          <img src={Logout} className="menu-icon" alt={"logout"} width="48" height="48" />
          </div>
          <div className="info">
          <h2>Logout</h2>
          <p>Are you sure you want to logout from the application?</p>
          </div>
          <div className="button-container">
            <button className="cancel-button" onClick={onCancel}>
              Cancel
            </button>
            <button className="logout-button" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  };

export default LogoutModal;
